// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__TY5FA","undone":"breadcrumb_undone__F3g53"};